import React from 'react';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import { WorkerUpdateContent } from './WorkerUpdateContent';
import { PsPage } from '../../../../shared/components/ps-page/PsPage';
import { BreadcrumbsManagerInstance } from '../../../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../../../shared/breadcrumbs/Breadcrumbs';
import RouterUtils from '../../../../shared/routing/RouterUtils';
import { PsRoutes } from '../../../../shared/routing/Routes';

export class WorkerUpdateScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_OUTSOURCES,
            Breadcrumbs.MY_OUTSOURCES_DETAIL,
            Breadcrumbs.WORKERS_EMPTY,
            Breadcrumbs.MY_OUTSOURCES_WORKERS_DETAIL,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;
        const { workerId } = this.props.match.params;

        return (
            <PsPage title={I18nUtils.tr('TR_TRABAJADOR_DE_MI_SUBCONTRATA')} breadcrumbs={breadcrumbs}>
                <WorkerUpdateContent
                    id={Number(workerId)}
                    appendBreadcrumb={this.appendBreadcrumb}
                />
            </PsPage>
        );
    }

    appendBreadcrumb = (worker) => {
        const { location, match } = this.props;
        const { outsourceId } = match.params;

        BreadcrumbsManagerInstance.finishLoading({
            id: Breadcrumbs.MY_OUTSOURCES_DETAIL.id,
            url: RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_DETAIL, { id: outsourceId }),
            description: worker.companyDescription(),
        });

        BreadcrumbsManagerInstance.finishLoading({
            id: Breadcrumbs.MY_OUTSOURCES_WORKERS_DETAIL.id,
            url: location.pathname,
            description: worker.completeName(),
        });

        this.setState({
            breadcrumbs: [...BreadcrumbsManagerInstance.breadcrumbs()],
        });
    };
}

WorkerUpdateScreen.propTypes = {};

WorkerUpdateScreen.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-outsources/worker/form/update/WorkerUpdateScreen.jsx